<mat-button-toggle-group
    class="button-toggle-height"
    [value]="currentValue()"
    (change)="onStatusChange($event.value)"
    [disabled]="disabled()"
    [multiple]="false"
    [hideSingleSelectionIndicator]="true">
    @for(option of statusOptions(); track option.value) {
        <mat-button-toggle
            [value]="option.value"
            [matTooltip]="option.tooltip"
            [class]="'status-' + option.value">
            <i [class]="option.icon"></i>
        </mat-button-toggle>
    }
</mat-button-toggle-group>